import { render } from "./feature-create-import.vue?vue&type=template&id=7ed52f4f"
import script from "./feature-create-import.vue?vue&type=script&lang=js"
export * from "./feature-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__